// File: frontend/src/components/FitenkoRail.js
// Version: 1.0 (quick-260909-qa3)
// Date: 2026-09-09
// Назначение: разметка левой колонки арендатора fitenko — голова, группы,
//             пункты со значком и числом, блок пользователя.
//
// 🔴 КОМПОНЕНТ МЕТОК НЕ ДЕРЖИТ. Заголовки групп и порядок разделов живут в
//    RAIL_GROUPS (config/fitenkoNav.js) и приходят сюда через `groupRail`;
//    метки разделов приходят из модели меню. Ни одна из них не написана здесь
//    литералом — это проверяется воротами В7 задачи 4.
//
// 🔴 ТРИ СОСТОЯНИЯ ЧИСЛА, а не два:
//      число есть   → рисуется («3»); усечённое рисуется как «20+»;
//      value === 0  → РИСУЕТСЯ «0»: пусто — это факт, и человек вправе его знать;
//      value null или ключа нет → НЕ РИСУЕТСЯ ВООБЩЕ.
//    Слить последние два с нулём значило бы сказать «у вас ничего нет» там, где
//    правда — «мы не знаем». [[feedback_unknown_is_not_no]]
//
// 🔴 ШЕВРОНА У БЛОКА ПОЛЬЗОВАТЕЛЯ НЕТ: меню, которое он обещает, не существует.
//    Блок — ссылка на /profile. [[knowledge_decorative_flag]]

import React from 'react';
import { NavLink } from 'react-router-dom';
import { groupRail } from '../config/fitenkoNav';
import { RAIL_ICONS } from '../config/fitenkoRailIcons';
import { useUiLanguage } from '../context/UiLanguageContext';

// Возвращает СТРОКУ для отрисовки или null, если числа нет.
export const chisloDlyaPunkta = (zapis) => {
    if (!zapis || typeof zapis.value !== 'number') return null;   // НЕИЗВЕСТНО ≠ НОЛЬ
    return zapis.capped ? `${zapis.value}+` : String(zapis.value);
};

// Инициалы вычисляются ИЗ ИМЕНИ, которое уже показано рядом, — не из отдельного
// источника: два источника разошлись бы, и кружок начал бы врать про соседа.
export const initsialy = (imya) => String(imya || '')
    .split(/[\s@._-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('');

// Голова колонки: две строки. Первая — словесный знак продукта (не утверждение о
// состоянии, поэтому литерал законен). Вторая — имя арендатора из branding:
// литерал здесь означал бы, что MLG увидит «Fitenko Law».
export const FitenkoRailHead = ({ tenant }) => (
    <span className="fk-rail-head">
        <span className="fk-rail-mark">OS OFFICE LAW</span>
        {tenant ? <span className="fk-rail-tenant" data-user-content="true">{tenant}</span> : null}
    </span>
);

// Блок пользователя. Живёт ВНУТРИ существующего .navbar-user-section: перенос
// его в другое место разметки задел бы MLG. Вниз колонки он переезжает СТИЛЯМИ.
export const FitenkoRailUser = ({ name, role }) => {
    const { t } = useUiLanguage();
    return (
        <>
            <span className="fk-rail-avatar" aria-hidden="true">{initsialy(name)}</span>
            <span className="fk-rail-who">
                <span className="fk-rail-name" data-user-content="true">{name}</span>
                {role ? <span className="fk-rail-role">{t(`shell.role.${role}`, role)}</span> : null}
            </span>
        </>
    );
};

const FitenkoRail = ({ sections, counters, onLinkClick }) => {
    const { t } = useUiLanguage();
    const gruppy = groupRail(sections);
    return (
        <>
            {gruppy.map((g) => (
                <div className="fk-rail-group" key={g.id}>
                    {g.label === null ? null : (
                        <div className="fk-rail-group-title">{t(`shell.rail.group.${g.id}`, g.label)}</div>
                    )}
                    {g.items.map((s) => {
                        const Znachok = RAIL_ICONS[s.id];
                        const n = chisloDlyaPunkta(counters ? counters[s.id] : null);
                        return (
                            <NavLink
                                key={s.id}
                                to={s.path}
                                onClick={onLinkClick}
                                className={({ isActive }) => `fk-rail-item text-foreground hover:bg-muted ${isActive ? 'active' : ''}`}
                            >
                                {Znachok ? (
                                    <Znachok className="fk-rail-icon" size={18} strokeWidth={1.5} aria-hidden="true" />
                                ) : null}
                                <span className="fk-rail-label">{t(`shell.section.${s.id}`, s.label)}</span>
                                {n === null ? null : <span className="fk-rail-count">{n}</span>}
                            </NavLink>
                        );
                    })}
                </div>
            ))}
        </>
    );
};

export default FitenkoRail;
